import { useQuery } from '@tanstack/react-query';

import { PLAYER_BANNER_KEY } from '@/hooks/player-details/constants';
import { getPlayerBanner } from '@/infrastructure/network/data/player-details/player-banner';
import { useOrganizationStore } from '@/store/organization-store';

export const usePlayerBannerQuery = (teamLeagueUuid: string, playerUuid: string) => {
	const store = useOrganizationStore();
	return useQuery({
		queryKey: [PLAYER_BANNER_KEY, store.organizationUuid, teamLeagueUuid, playerUuid],
		queryFn: () => getPlayerBanner({ organizationUuid: store.organizationUuid, teamLeagueUuid, playerUuid }),
		enabled: !!(store.organizationUuid && teamLeagueUuid && playerUuid)
	});
};
